module.exports = __webpack_public_path__ + "img/sabasysmex.e39b65e0.png";